import { HintsGroup } from "../Hint";

const hints = [
  {
    name: "ImportMusicxmlPiecePageHintsListen",
    hints: [
      {
        hint: "Cliquez ici pour importer votre propre morceau au format MusicXML.",
        element: "#import-piece-button-tips",
        hintPosition: "top-right"
      }
    ]
  }
] as HintsGroup[];

export default {
  hints
};